import Route from '@ember/routing/route';

import type { ProgramsProgramCohortCoachingModel } from '../coaching.ts';

/**
 * The coaching route now has children (the coachees oversight page), so its
 * template is just an outlet; this index route carries the coaching edit form
 * and reuses the parent route's already-resolved model.
 */
export default class ProgramsProgramCohortCoachingIndexRoute extends Route<ProgramsProgramCohortCoachingModel> {
  model(): ProgramsProgramCohortCoachingModel {
    return this.modelFor(
      'programs.program.cohort.coaching'
    ) as ProgramsProgramCohortCoachingModel;
  }
}
